import React, { useState, useEffect } from "react";
import { userEndpoint, Base_URL } from "actions/API_endpoint";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";

export default function StudentProjects() {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedProject, setSelectedProject] = useState(null);

    useEffect(() => {
        const fetchStudentProjects = async () => {
            try {
                const token = localStorage.getItem("token");
                if (!token) return;
                const decoded = jwtDecode(token);
                const userId = decoded.user_id || decoded.id; // handle both cases

                const response = await fetch(`${Base_URL}${userEndpoint.getStudentProjects(userId)}`);
                const data = await response.json();

                if (data.success) {
                    setProjects(data.data);
                }
            } catch (error) {
                console.error("Error fetching student projects:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchStudentProjects();
    }, []);

    const viewProjectDetails = (project) => {
        setSelectedProject(project);
    };

    return (
        <div className="flex flex-wrap mt-4 text-white">
            {!selectedProject ? (
                // List of Projects
                <div className="w-full px-4 mb-12">
                    <div className="relative flex flex-col min-w-0 break-words bg-dark-secondary w-full mb-6 shadow-xl rounded-lg">
                        <div className="rounded-t mb-0 px-4 py-3 border-0 bg-dark-tertiary">
                            <h3 className="font-semibold text-lg text-white">My Projects (MPDI/IPD)</h3>
                        </div>
                        <div className="block w-full overflow-x-auto min-h-[400px]">
                            {loading ? (
                                <div className="flex justify-center items-center h-48">Loading...</div>
                            ) : (
                                <table className="items-center w-full bg-transparent border-collapse">
                                    <thead>
                                        <tr>
                                            <th className="px-6 py-3 bg-dark-tertiary text-gray-300 align-middle border border-solid border-dark-tertiary text-xs uppercase font-semibold text-left">Project ID</th>
                                            <th className="px-6 py-3 bg-dark-tertiary text-gray-300 align-middle border border-solid border-dark-tertiary text-xs uppercase font-semibold text-left">Project Name</th>
                                            <th className="px-6 py-3 bg-dark-tertiary text-gray-300 align-middle border border-solid border-dark-tertiary text-xs uppercase font-semibold text-left">Scheme</th>
                                            <th className="px-6 py-3 bg-dark-tertiary text-gray-300 align-middle border border-solid border-dark-tertiary text-xs uppercase font-semibold text-left">Leader</th>
                                            <th className="px-6 py-3 bg-dark-tertiary text-gray-300 align-middle border border-solid border-dark-tertiary text-xs uppercase font-semibold text-left">Status</th>
                                            <th className="px-6 py-3 bg-dark-tertiary text-gray-300 align-middle border border-solid border-dark-tertiary text-xs uppercase font-semibold text-left">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {projects.length > 0 ? projects.map(p => (
                                            <tr key={p.id} className="border-b border-dark-tertiary hover:bg-dark-tertiary/50 transition-colors">
                                                <td className="px-6 py-4 align-middle text-gray-300 font-mono text-sm">{p.project_id || 'N/A'}</td>
                                                <td className="px-6 py-4 align-middle font-bold">{p.project_name}</td>
                                                <td className="px-6 py-4 align-middle uppercase text-xs">
                                                    <span className={`px-2 py-1 rounded text-xs font-bold uppercase ${p.scheme === 'mpdi' ? 'bg-blue-500/20 text-blue-400' : 'bg-purple-500/20 text-purple-400'}`}>
                                                        {p.scheme}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 align-middle text-sm text-gray-300">
                                                    {p.team_leader_data ? `${p.team_leader_data.first_name} ${p.team_leader_data.last_name}` : p.team_leader}
                                                </td>
                                                <td className="px-6 py-4 align-middle text-sm text-gray-300 uppercase">
                                                    <span className={p.status === 'active' ? 'text-green-400' : 'text-red-400'}>{p.status}</span>
                                                </td>
                                                <td className="px-6 py-4 align-middle text-sm">
                                                    <button
                                                        onClick={() => viewProjectDetails(p)}
                                                        className="bg-accent-primary hover:bg-accent-hover text-white active:bg-blue-600 font-bold uppercase text-xs px-3 py-1 rounded shadow"
                                                    >
                                                        View Evaluations
                                                    </button>
                                                </td>
                                            </tr>
                                        )) : (
                                            <tr><td colSpan="5" className="text-center py-6 text-gray-500">You do not have any active projects.</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            ) : (
                // Project Details & Evaluations View
                <div className="w-full mt-4 mb-12">
                    <div className="flex flex-wrap -mx-4">
                        <div className="w-full xl:w-4/12 px-4 mb-6 xl:mb-0">
                            <div className="relative flex flex-col min-w-0 break-words bg-dark-secondary w-full mb-6 shadow-xl rounded-lg p-6 h-full z-10">
                                <h4 className="text-xl font-bold mb-4">{selectedProject.project_name} <span className="text-sm font-mono text-gray-400 ml-2">({selectedProject.project_id || 'N/A'})</span></h4>
                                <ul className="space-y-3 text-gray-300 text-sm">
                                    <li><strong>Scheme:</strong> <span className="uppercase">{selectedProject.scheme}</span></li>
                                    <li><strong>Semester Registered:</strong> <span>{selectedProject.Semester_Registered || "N/A"}</span></li>
                                    <li><strong>Academic Year:</strong> <span>{selectedProject.Academic_Year || "N/A"}</span></li>
                                    <li><strong>Status:</strong> <span className={`uppercase ${selectedProject.status === 'active' ? 'text-green-400' : 'text-red-400'}`}>{selectedProject.status}</span></li>
                                    <li><strong>Mentor:</strong> {selectedProject.mentor_name || "N/A"}</li>
                                    <li className="pt-2 border-t border-dark-tertiary">
                                        <strong>Team Leader:</strong><br />
                                        {selectedProject.team_leader_data ? `${selectedProject.team_leader_data.first_name} ${selectedProject.team_leader_data.last_name}` : selectedProject.team_leader}
                                    </li>
                                    <li>
                                        <strong>Members:</strong>
                                        <ul className="list-disc pl-5 mt-1 text-gray-400">
                                            {selectedProject.team_members_data && selectedProject.team_members_data.map((m, i) => (
                                                m && <li key={i}>{m.first_name} {m.last_name}</li>
                                            ))}
                                            {(!selectedProject.team_members_data || selectedProject.team_members_data.length === 0) && (
                                                <li>No other members</li>
                                            )}
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="w-full xl:w-8/12 px-4">
                            <div className="relative flex flex-col min-w-0 break-words bg-dark-secondary w-full mb-6 shadow-xl rounded-lg overflow-hidden h-full z-10">
                                <div className="px-6 py-4 bg-dark-tertiary border-b border-white/5 flex justify-between items-center">
                                    <h4 className="font-bold text-lg">Monthly Evaluations</h4>
                                    <button
                                        onClick={() => setSelectedProject(null)}
                                        className="bg-gray-600 hover:bg-gray-500 text-white font-bold uppercase text-xs px-4 py-2 rounded shadow transition-colors"
                                    >
                                        <i className="fas fa-arrow-left mr-2"></i>Back
                                    </button>
                                </div>
                                <div className="overflow-x-auto p-0">
                                    <table className="items-center w-full bg-transparent border-collapse text-sm">
                                        <thead>
                                            <tr>
                                                <th className="px-6 py-3 bg-dark-tertiary text-gray-400 text-xs font-semibold uppercase text-left">Month/Year</th>
                                                <th className="px-6 py-3 bg-dark-tertiary text-gray-400 text-xs font-semibold uppercase text-left">Evaluation</th>
                                                {selectedProject.scheme === 'mpdi' && (
                                                    <>
                                                        <th className="px-6 py-3 bg-dark-tertiary text-gray-400 text-xs font-semibold uppercase text-left">Stipend</th>
                                                        <th className="px-6 py-3 bg-dark-tertiary text-gray-400 text-xs font-semibold uppercase text-left">Status</th>
                                                    </>
                                                )}
                                                <th className="px-6 py-3 bg-dark-tertiary text-gray-400 text-xs font-semibold uppercase text-left">Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedProject.evaluations && selectedProject.evaluations.length > 0 ? (
                                                [...selectedProject.evaluations].sort((a, b) => {
                                                    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                                                    if (a.eval_year !== b.eval_year) {
                                                        return a.eval_year - b.eval_year;
                                                    }
                                                    return months.indexOf(a.eval_month) - months.indexOf(b.eval_month);
                                                }).map(ev => (
                                                    <tr key={ev.id} className="border-b border-dark-tertiary hover:bg-white/5">
                                                        <td className="px-6 py-4 font-bold">{ev.eval_month} {ev.eval_year}</td>
                                                        <td className={`px-6 py-4 font-bold uppercase text-xs ${ev.evaluation === 'satisfactory' ? 'text-green-400' : 'text-red-400'}`}>
                                                            {ev.evaluation}
                                                        </td>
                                                        {selectedProject.scheme === 'mpdi' && (
                                                            <>
                                                                <td className="px-6 py-4">₹{ev.stipend || 0}</td>
                                                                <td className={`px-6 py-4 uppercase text-xs ${ev.stipend_status === 'paid' ? 'text-green-400' : 'text-yellow-400'}`}>
                                                                    {ev.stipend_status}
                                                                </td>
                                                            </>
                                                        )}
                                                        <td className="px-6 py-4 text-gray-400 max-w-xs" title={ev.comment}>
                                                            <div className="flex items-center">
                                                                <span className="truncate">{ev.comment || "-"}</span>
                                                                {ev.comment && ev.comment.length > 20 && (
                                                                    <button
                                                                        onClick={() => Swal.fire({
                                                                            title: 'Evaluation Comment',
                                                                            text: ev.comment,
                                                                            icon: 'info',
                                                                            background: '#0f2847',
                                                                            color: '#fff',
                                                                            confirmButtonColor: '#3b82f6',
                                                                        })}
                                                                        className="ml-2 text-accent-primary hover:text-accent-hover focus:outline-none"
                                                                        title="View Full Comment"
                                                                    >
                                                                        <i className="fas fa-eye"></i>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center py-6 text-gray-500">No evaluations have been posted yet.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
